const english = {
  startsWith: 'Starts with',
  contains: 'Contains',
  notContains: 'Does not contain',
  endsWith: 'Ends with',
  equals: 'Equals',
  notEquals: 'Does not equal',
  noFilter: 'No filter',
  lt: 'Less than',
  lte: 'Less than or equal to',
  gt: 'Greater than',
  gte: 'Greater than or equal to',
  dateIs: 'Date is',
  dateIsNot: 'Date is not',
  dateBefore: 'Date is before',
  dateAfter: 'Date is after',
  clear: 'Clear',
  apply: 'Apply',
  matchAll: 'Match all',
  matchAny: 'Match any',
  addRule: 'Add rule',
  removeRule: 'Remove rule',
  accept: 'Yes',
  reject: 'No',
  choose: 'Choose',
  upload: 'Upload',
  cancel: 'Cancel',
  completed: 'Completed',
  pending: 'Pending',
  fileSizeTypes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
  dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
  dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  chooseYear: 'Choose year',
  chooseMonth: 'Choose month',
  chooseDate: 'Choose date',
  prevDecade: 'Previous decade',
  nextDecade: 'Next decade',
  prevYear: 'Previous year',
  nextYear: 'Next year',
  prevMonth: 'Previous month',
  nextMonth: 'Next month',
  prevHour: 'Previous hour',
  nextHour: 'Next hour',
  prevMinute: 'Previous minute',
  nextMinute: 'Next minute',
  prevSecond: 'Previous second',
  nextSecond: 'Next second',
  am: 'am',
  pm: 'pm',
  today: 'Today',
  weekHeader: 'Wk',
  firstDayOfWeek: 1,
  showMonthAfterYear: false,
  dateFormat: 'dd/mm/yy',
  weak: 'Weak',
  medium: 'Medium',
  strong: 'Strong',
  passwordPrompt: 'Enter a password',
  emptyFilterMessage: 'No results found',
  searchMessage: '{0} results are available',
  selectionMessage: '{0} items selected',
  emptySelectionMessage: 'No selected item',
  emptySearchMessage: 'No results found',
  fileChosenMessage: '{0} files',
  noFileChosenMessage: 'No file chosen',
  emptyMessage: 'No options available',
  aria: {
    trueLabel: 'True',
    falseLabel: 'False',
    nullLabel: 'Not selected',
    star: '1 star',
    stars: '{star} stars',
    selectAll: 'All items selected',
    unselectAll: 'All items unselected',
    close: 'Close',
    previous: 'Previous',
    next: 'Next',
    navigation: 'Navigation',
    scrollTop: 'Scroll to top',
    moveTop: 'Move to top',
    moveUp: 'Move up',
    moveDown: 'Move down',
    moveBottom: 'Move to bottom',
    moveToTarget: 'Move to target',
    moveToSource: 'Move to source',
    moveAllToTarget: 'Move all to target',
    moveAllToSource: 'Move all to source',
    pageLabel: 'Page {page}',
    firstPageLabel: 'First page',
    lastPageLabel: 'Last page',
    nextPageLabel: 'Next page',
    prevPageLabel: 'Previous page',
    rowsPerPageLabel: 'Rows per page',
    jumpToPageDropdownLabel: 'Jump to page',
    jumpToPageInputLabel: 'Enter page number',
    selectRow: 'Row selected',
    unselectRow: 'Row unselected',
    expandRow: 'Row expanded',
    collapseRow: 'Row collapsed',
    showFilterMenu: 'Show filter menu',
    hideFilterMenu: 'Hide filter menu',
    filterOperator: 'Filter operator',
    filterConstraint: 'Filter constraint',
    editRow: 'Edit row',
    saveEdit: 'Save edit',
    cancelEdit: 'Cancel edit',
    listView: 'List view',
    gridView: 'Grid view',
    slide: 'Slide',
    slideNumber: 'Slide {slideNumber}',
    zoomImage: 'Zoom image',
    zoomIn: 'Zoom in',
    zoomOut: 'Zoom out',
    rotateRight: 'Rotate right',
    rotateLeft: 'Rotate left',
    listLabel: 'Option list',
  },
};

const makeLocale = (overrides) => ({
  ...english,
  ...overrides,
  aria: {
    ...english.aria,
    ...(overrides.aria || {}),
  },
});

const dutch = makeLocale({
  startsWith: 'Begint met', contains: 'Bevat', notContains: 'Bevat niet', endsWith: 'Eindigt met',
  equals: 'Is gelijk aan', notEquals: 'Is niet gelijk aan', noFilter: 'Geen filter', lt: 'Kleiner dan',
  lte: 'Kleiner dan of gelijk aan', gt: 'Groter dan', gte: 'Groter dan of gelijk aan', dateIs: 'Datum is',
  dateIsNot: 'Datum is niet', dateBefore: 'Datum is vóór', dateAfter: 'Datum is na', clear: 'Wissen',
  apply: 'Toepassen', matchAll: 'Voldoet aan alle', matchAny: 'Voldoet aan één', addRule: 'Regel toevoegen',
  removeRule: 'Regel verwijderen', accept: 'Ja', reject: 'Nee', choose: 'Kiezen', upload: 'Uploaden',
  cancel: 'Annuleren', completed: 'Voltooid', pending: 'In behandeling',
  dayNames: ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'],
  dayNamesShort: ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'], dayNamesMin: ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'],
  monthNames: ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'],
  monthNamesShort: ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'],
  chooseYear: 'Jaar kiezen', chooseMonth: 'Maand kiezen', chooseDate: 'Datum kiezen',
  prevDecade: 'Vorig decennium', nextDecade: 'Volgend decennium', prevYear: 'Vorig jaar', nextYear: 'Volgend jaar',
  prevMonth: 'Vorige maand', nextMonth: 'Volgende maand', prevHour: 'Vorig uur', nextHour: 'Volgend uur',
  prevMinute: 'Vorige minuut', nextMinute: 'Volgende minuut', prevSecond: 'Vorige seconde', nextSecond: 'Volgende seconde',
  today: 'Vandaag', weekHeader: 'Wk', dateFormat: 'dd/mm/yy', weak: 'Zwak', medium: 'Gemiddeld', strong: 'Sterk',
  passwordPrompt: 'Voer een wachtwoord in', emptyFilterMessage: 'Geen resultaten gevonden',
  searchMessage: '{0} resultaten beschikbaar', selectionMessage: '{0} items geselecteerd',
  emptySelectionMessage: 'Geen item geselecteerd', emptySearchMessage: 'Geen resultaten gevonden',
  fileChosenMessage: '{0} bestanden', noFileChosenMessage: 'Geen bestand gekozen', emptyMessage: 'Geen opties beschikbaar',
  aria: {
    trueLabel: 'Waar', falseLabel: 'Onwaar', nullLabel: 'Niet geselecteerd', star: '1 ster', stars: '{star} sterren',
    selectAll: 'Alle items geselecteerd', unselectAll: 'Alle items gedeselecteerd', close: 'Sluiten', previous: 'Vorige', next: 'Volgende',
    navigation: 'Navigatie', scrollTop: 'Naar boven scrollen', moveTop: 'Naar boven verplaatsen', moveUp: 'Omhoog verplaatsen',
    moveDown: 'Omlaag verplaatsen', moveBottom: 'Naar onder verplaatsen', moveToTarget: 'Naar doel verplaatsen',
    moveToSource: 'Naar bron verplaatsen', moveAllToTarget: 'Alles naar doel verplaatsen',
    moveAllToSource: 'Alles naar bron verplaatsen', pageLabel: 'Pagina {page}',
    firstPageLabel: 'Eerste pagina', lastPageLabel: 'Laatste pagina', nextPageLabel: 'Volgende pagina', prevPageLabel: 'Vorige pagina',
    rowsPerPageLabel: 'Rijen per pagina', jumpToPageDropdownLabel: 'Naar pagina gaan', jumpToPageInputLabel: 'Paginanummer invoeren',
    selectRow: 'Rij geselecteerd', unselectRow: 'Rij gedeselecteerd', expandRow: 'Rij uitgeklapt', collapseRow: 'Rij ingeklapt',
    showFilterMenu: 'Filtermenu tonen', hideFilterMenu: 'Filtermenu verbergen', filterOperator: 'Filteroperator',
    filterConstraint: 'Filtervoorwaarde', editRow: 'Rij bewerken', saveEdit: 'Bewerking opslaan', cancelEdit: 'Bewerking annuleren',
    listView: 'Lijstweergave', gridView: 'Rasterweergave', slide: 'Dia', slideNumber: 'Dia {slideNumber}',
    zoomImage: 'Afbeelding vergroten', zoomIn: 'Inzoomen', zoomOut: 'Uitzoomen', rotateRight: 'Rechtsom draaien',
    rotateLeft: 'Linksom draaien', listLabel: 'Optielijst',
  },
});

const french = makeLocale({
  startsWith: 'Commence par', contains: 'Contient', notContains: 'Ne contient pas', endsWith: 'Se termine par',
  equals: 'Est égal à', notEquals: 'N’est pas égal à', noFilter: 'Aucun filtre', lt: 'Inférieur à',
  lte: 'Inférieur ou égal à', gt: 'Supérieur à', gte: 'Supérieur ou égal à', dateIs: 'La date est',
  dateIsNot: 'La date n’est pas', dateBefore: 'La date précède', dateAfter: 'La date suit', clear: 'Effacer',
  apply: 'Appliquer', matchAll: 'Correspond à toutes', matchAny: 'Correspond à une', addRule: 'Ajouter une règle',
  removeRule: 'Supprimer la règle', accept: 'Oui', reject: 'Non', choose: 'Choisir', upload: 'Téléverser',
  cancel: 'Annuler', completed: 'Terminé', pending: 'En attente',
  dayNames: ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'],
  dayNamesShort: ['dim', 'lun', 'mar', 'mer', 'jeu', 'ven', 'sam'], dayNamesMin: ['di', 'lu', 'ma', 'me', 'je', 've', 'sa'],
  monthNames: ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'],
  monthNamesShort: ['janv', 'févr', 'mars', 'avr', 'mai', 'juin', 'juil', 'août', 'sept', 'oct', 'nov', 'déc'],
  chooseYear: 'Choisir l’année', chooseMonth: 'Choisir le mois', chooseDate: 'Choisir la date',
  prevDecade: 'Décennie précédente', nextDecade: 'Décennie suivante', prevYear: 'Année précédente', nextYear: 'Année suivante',
  prevMonth: 'Mois précédent', nextMonth: 'Mois suivant', prevHour: 'Heure précédente', nextHour: 'Heure suivante',
  prevMinute: 'Minute précédente', nextMinute: 'Minute suivante', prevSecond: 'Seconde précédente', nextSecond: 'Seconde suivante',
  today: 'Aujourd’hui', weekHeader: 'Sem', dateFormat: 'dd/mm/yy', weak: 'Faible', medium: 'Moyen', strong: 'Fort',
  passwordPrompt: 'Saisissez un mot de passe', emptyFilterMessage: 'Aucun résultat trouvé',
  searchMessage: '{0} résultats disponibles', selectionMessage: '{0} éléments sélectionnés',
  emptySelectionMessage: 'Aucun élément sélectionné', emptySearchMessage: 'Aucun résultat trouvé',
  fileChosenMessage: '{0} fichiers', noFileChosenMessage: 'Aucun fichier choisi', emptyMessage: 'Aucune option disponible',
  aria: {
    trueLabel: 'Vrai', falseLabel: 'Faux', nullLabel: 'Non sélectionné', star: '1 étoile', stars: '{star} étoiles',
    selectAll: 'Tous les éléments sélectionnés', unselectAll: 'Tous les éléments désélectionnés', close: 'Fermer',
    previous: 'Précédent', next: 'Suivant', navigation: 'Navigation', scrollTop: 'Faire défiler vers le haut',
    moveTop: 'Déplacer en haut', moveUp: 'Déplacer vers le haut', moveDown: 'Déplacer vers le bas', moveBottom: 'Déplacer en bas',
    moveToTarget: 'Déplacer vers la cible', moveToSource: 'Déplacer vers la source',
    moveAllToTarget: 'Tout déplacer vers la cible', moveAllToSource: 'Tout déplacer vers la source',
    pageLabel: 'Page {page}', firstPageLabel: 'Première page', lastPageLabel: 'Dernière page', nextPageLabel: 'Page suivante',
    prevPageLabel: 'Page précédente', rowsPerPageLabel: 'Lignes par page', jumpToPageDropdownLabel: 'Aller à la page',
    jumpToPageInputLabel: 'Saisir le numéro de page', selectRow: 'Ligne sélectionnée', unselectRow: 'Ligne désélectionnée',
    expandRow: 'Ligne développée', collapseRow: 'Ligne réduite', showFilterMenu: 'Afficher le menu des filtres',
    hideFilterMenu: 'Masquer le menu des filtres', filterOperator: 'Opérateur de filtre', filterConstraint: 'Contrainte de filtre',
    editRow: 'Modifier la ligne', saveEdit: 'Enregistrer la modification', cancelEdit: 'Annuler la modification',
    listView: 'Vue en liste', gridView: 'Vue en grille', slide: 'Diapositive', slideNumber: 'Diapositive {slideNumber}',
    zoomImage: 'Agrandir l’image', zoomIn: 'Zoom avant', zoomOut: 'Zoom arrière', rotateRight: 'Pivoter à droite',
    rotateLeft: 'Pivoter à gauche', listLabel: 'Liste d’options',
  },
});

const german = makeLocale({
  startsWith: 'Beginnt mit', contains: 'Enthält', notContains: 'Enthält nicht', endsWith: 'Endet mit',
  equals: 'Ist gleich', notEquals: 'Ist nicht gleich', noFilter: 'Kein Filter', lt: 'Kleiner als',
  lte: 'Kleiner oder gleich', gt: 'Größer als', gte: 'Größer oder gleich', dateIs: 'Datum ist',
  dateIsNot: 'Datum ist nicht', dateBefore: 'Datum liegt vor', dateAfter: 'Datum liegt nach', clear: 'Löschen',
  apply: 'Anwenden', matchAll: 'Alle erfüllen', matchAny: 'Mindestens eines erfüllen', addRule: 'Regel hinzufügen',
  removeRule: 'Regel entfernen', accept: 'Ja', reject: 'Nein', choose: 'Auswählen', upload: 'Hochladen',
  cancel: 'Abbrechen', completed: 'Abgeschlossen', pending: 'Ausstehend',
  dayNames: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
  dayNamesShort: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'], dayNamesMin: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
  monthNames: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
  monthNamesShort: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
  chooseYear: 'Jahr auswählen', chooseMonth: 'Monat auswählen', chooseDate: 'Datum auswählen',
  prevDecade: 'Vorheriges Jahrzehnt', nextDecade: 'Nächstes Jahrzehnt', prevYear: 'Vorheriges Jahr', nextYear: 'Nächstes Jahr',
  prevMonth: 'Vorheriger Monat', nextMonth: 'Nächster Monat', prevHour: 'Vorherige Stunde', nextHour: 'Nächste Stunde',
  prevMinute: 'Vorherige Minute', nextMinute: 'Nächste Minute', prevSecond: 'Vorherige Sekunde', nextSecond: 'Nächste Sekunde',
  today: 'Heute', weekHeader: 'KW', dateFormat: 'dd.mm.yy', weak: 'Schwach', medium: 'Mittel', strong: 'Stark',
  passwordPrompt: 'Passwort eingeben', emptyFilterMessage: 'Keine Ergebnisse gefunden',
  searchMessage: '{0} Ergebnisse verfügbar', selectionMessage: '{0} Elemente ausgewählt',
  emptySelectionMessage: 'Kein Element ausgewählt', emptySearchMessage: 'Keine Ergebnisse gefunden',
  fileChosenMessage: '{0} Dateien', noFileChosenMessage: 'Keine Datei ausgewählt', emptyMessage: 'Keine Optionen verfügbar',
  aria: {
    trueLabel: 'Wahr', falseLabel: 'Falsch', nullLabel: 'Nicht ausgewählt', star: '1 Stern', stars: '{star} Sterne',
    selectAll: 'Alle Elemente ausgewählt', unselectAll: 'Alle Elemente abgewählt', close: 'Schließen', previous: 'Zurück', next: 'Weiter',
    navigation: 'Navigation', scrollTop: 'Nach oben scrollen', moveTop: 'Ganz nach oben verschieben', moveUp: 'Nach oben verschieben',
    moveDown: 'Nach unten verschieben', moveBottom: 'Ganz nach unten verschieben', moveToTarget: 'Zum Ziel verschieben',
    moveToSource: 'Zur Quelle verschieben', moveAllToTarget: 'Alles zum Ziel verschieben',
    moveAllToSource: 'Alles zur Quelle verschieben', pageLabel: 'Seite {page}',
    firstPageLabel: 'Erste Seite', lastPageLabel: 'Letzte Seite', nextPageLabel: 'Nächste Seite', prevPageLabel: 'Vorherige Seite',
    rowsPerPageLabel: 'Zeilen pro Seite', jumpToPageDropdownLabel: 'Zu Seite springen', jumpToPageInputLabel: 'Seitennummer eingeben',
    selectRow: 'Zeile ausgewählt', unselectRow: 'Zeile abgewählt', expandRow: 'Zeile aufgeklappt', collapseRow: 'Zeile eingeklappt',
    showFilterMenu: 'Filtermenü anzeigen', hideFilterMenu: 'Filtermenü ausblenden', filterOperator: 'Filteroperator',
    filterConstraint: 'Filterbedingung', editRow: 'Zeile bearbeiten', saveEdit: 'Bearbeitung speichern', cancelEdit: 'Bearbeitung abbrechen',
    listView: 'Listenansicht', gridView: 'Rasteransicht', slide: 'Folie', slideNumber: 'Folie {slideNumber}',
    zoomImage: 'Bild vergrößern', zoomIn: 'Vergrößern', zoomOut: 'Verkleinern', rotateRight: 'Nach rechts drehen',
    rotateLeft: 'Nach links drehen', listLabel: 'Optionsliste',
  },
});

export const primeVueLocales = {
  nl: dutch,
  en: english,
  fr: french,
  de: german,
};

export default primeVueLocales;
